/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

import { ApiService } from '@shared/services/api.service'
import { Geofence, GeofenceGroup, GeofenceInput, GeofencesGroupInput } from '@app/modules/client/shared/models/geofence.model'
import { PagesData } from '@shared/models/pages-data.model'
import { FilterValues } from '@app/shared/models/filter-values.model'

@Injectable()
export class GeofencesApiService {
  constructor(private apiService: ApiService) {}

  getGeofences(
    pageIndex = 0,
    pageSize = 10,
    sort?: string,
    filterValues?: FilterValues,
    fields?: (keyof Geofence)[],
  ): Observable<PagesData<Geofence>> {
    return <Observable<PagesData<Geofence>>>this.apiService.getPageable<Geofence>('/areas', pageIndex, pageSize, sort, filterValues, fields)
  }

  getGeofencesList(filterValues?: FilterValues, fields?: (keyof Geofence)[], sort?: string): Observable<Geofence[]> {
    return this.getGeofences(0, 10000, sort, filterValues, fields).pipe(map((resp) => resp['data']))
  }

  getGeofence(id: string): Observable<Geofence> {
    return <Observable<Geofence>>this.apiService.get(`/areas/${id}`).pipe(map((response) => response['data']))
  }

  addGeofence(geofence: GeofenceInput): Observable<Geofence> {
    return this.apiService.post<Geofence>('/areas', geofence).pipe(map((response) => response['data']))
  }

  updateGeofence(id: number, geofence: GeofenceInput): Observable<Geofence> {
    return this.apiService.patch(`/areas/${id}`, geofence).pipe(map((response) => response['data']))
  }

  deleteGeofence(id: number) {
    return this.apiService.delete(`/areas/${id}`)
  }

  archiveGeofence(id: number) {
    return this.apiService.patch(`/areas/${id}/archive`, {})
  }

  restoreGeofence(id: number): Observable<Geofence> {
    return <Observable<Geofence>>this.apiService.patch(`/areas/${id}/restore`, {}).pipe(map((response) => response['data']))
  }

  getGeofencesGroups(
    pageIndex = 0,
    pageSize = 10,
    sort?: string,
    filterValues?: FilterValues,
    fields?: (keyof GeofenceGroup)[],
  ): Observable<PagesData<GeofenceGroup>> {
    return this.apiService.getPageable<GeofenceGroup>('/area-groups', pageIndex, pageSize, sort, filterValues, fields)
  }

  getGeofencesGroup(id: string): Observable<GeofenceGroup> {
    return this.apiService.get(`/area-groups/${id}`).pipe(map((response) => response['data']))
  }

  getGeofencesGroupList(filterValues?: FilterValues, fields?: (keyof GeofenceGroup)[]): Observable<GeofenceGroup[]> {
    return this.getGeofencesGroups(0, 100, null, filterValues, fields).pipe(map((response) => response['data']))
  }

  addGeofencesGroup(group: GeofencesGroupInput): Observable<GeofenceGroup> {
    return this.apiService.post<GeofenceGroup>('/area-groups', group).pipe(map((response) => response['data']))
  }

  updateGeofencesGroup(id: number, group: GeofencesGroupInput): Observable<GeofenceGroup> {
    return this.apiService.patch(`/area-groups/${id}`, group).pipe(map((response) => response['data']))
  }

  deleteGeofencesGroup(id: number) {
    return this.apiService.delete(`/area-groups/${id}`)
  }

  archiveGeofencesGroup(id: number) {
    return this.apiService.patch(`/area-groups/${id}/archive`, {})
  }

  restoreGeofencesGroup(id: number): Observable<GeofenceGroup> {
    return this.apiService.patch(`/area-groups/${id}/restore`, {}).pipe(map((response) => response['data']))
  }
}
